// Device fingerprinting for Arena vote deduplication
// Uses FingerprintJS open-source library for browser-based device identification
// This fingerprint survives private browsing and cookie clearing in most cases

import FingerprintJS from "@fingerprintjs/fingerprintjs"

let fpPromise: Promise<string> | null = null

// Get device fingerprint (cached after first call)
export async function getDeviceFingerprint(): Promise<string> {
  if (!fpPromise) {
    fpPromise = loadFingerprint()
  }
  return fpPromise
}

async function loadFingerprint(): Promise<string> {
  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    return result.visitorId
  } catch (error) {
    console.warn("[DeviceFingerprint] Failed to load fingerprint:", error)
    // Return empty string on failure - server will fall back to cookie-only
    return ""
  }
}

// Pre-load fingerprint on page load for faster first vote
export function preloadFingerprint(): void {
  getDeviceFingerprint()
}
